import { pdf } from '@react-pdf/renderer'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Document, Page, pdfjs } from 'react-pdf'

// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

// 使用本地的 pdf.worker
pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.js'

const PDFViewer = ({ children, width }) => {
  const [pdfUrl, setPdfUrl] = useState(null)
  const [numPages, setNumPages] = useState(0)

  const { t } = useTranslation()

  const onDocumentLoadSuccess = useCallback(document => {
    const { numPages: nextNumPages } = document
    setNumPages(nextNumPages)
  }, [])

  useEffect(() => {
    const child = React.Children.only(children)

    pdf(child)
      .toBlob()
      .then(blob => {
        setPdfUrl(URL.createObjectURL(blob))
      })
  }, [children])

  return (
    <Document
      file={pdfUrl}
      onLoadSuccess={onDocumentLoadSuccess}
      noData={t('general.report_generating')}
      loading={t('general.report_loading')}
    >
      {Array.from(new Array(numPages), (_, index) => (
        <div key={`pdf_page_${index + 1}`}>
          <Page
            pageNumber={index + 1}
            width={width}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
          {index !== numPages - 1 && (
            <div style={{ width: '100%', height: 5, background: 'darkgrey' }}></div>
          )}
        </div>
      ))}
    </Document>
  )
}

export default PDFViewer
